import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState, MetaDataStatus } from 'data/model/app'
import { produce } from 'immer'
import { userConfig } from 'lib/config'
import { UnitType } from 'utils/storage'

const initialState: AppState = {
  browserMapHeaders: {
    city: 'Berlin',
    country: 'DE',
  },
  browserMapPosition: { lat: 52.5, lng: 13.4 },
  init: false,
  isMobileDevice: false,
  language: userConfig.language,
  status: null,
  unit: UnitType.automatic,
}

type BrowserMapHeaders = Pick<AppState, 'browserMapHeaders'>

const appSlice = createSlice({
  initialState,
  name: 'app',
  reducers: {
    fetchLocalizationData(state: AppState) {
      return produce(state, (draft) => {
        draft.status = MetaDataStatus.pending
      })
    },
    setBrowserMapHeaders(state: AppState, action: PayloadAction<BrowserMapHeaders>) {
      return produce(state, (draft) => {
        draft.browserMapHeaders = action.payload.browserMapHeaders
      })
    },
    setBrowserMapPosition(state: AppState, action: PayloadAction<{ lat: number; lng: number }>) {
      return produce(state, (draft) => {
        draft.browserMapPosition = action.payload
      })
    },
    setIsMobileDevice(state: AppState, action: PayloadAction<boolean>) {
      return produce(state, (draft) => {
        draft.isMobileDevice = action.payload
      })
    },
    setLanguage(state: AppState, action: PayloadAction<string>) {
      return produce(state, (draft) => {
        draft.language = action.payload
      })
    },
    setStatus(state: AppState, action: PayloadAction<MetaDataStatus>) {
      return produce(state, (draft) => {
        draft.status = action.payload
      })
    },
    setUnit(state: AppState, action: PayloadAction<string>) {
      return produce(state, (draft) => {
        draft.unit = action.payload
      })
    },
  },
})

export const {
  setLanguage,
  setUnit,
  fetchLocalizationData,
  setBrowserMapHeaders,
  setBrowserMapPosition,
  setIsMobileDevice,
  setStatus,
} = appSlice.actions

export const reducer = appSlice.reducer
